import {SurveyAggregationService} from "crqlar-react-common/dist/services/aggregation/surveyAggregation.service";
import {useQuery} from "react-query";
import type {DateRange} from "../../../common/newDatePicker/datePickerShared";
import {InsightsLoading} from "../../../insights/kit/insightsLoading";
import {SURVEY_SUMMARY_QUERY_KEY} from "../../shared/surveyQueryRefresh";
import {exclusiveEnd} from "../../shared/useSurveyEvaluation";

export const useSurveySummary = (range: DateRange, compareRange: DateRange | null) => {
    const query = useQuery(
        [
            SURVEY_SUMMARY_QUERY_KEY,
            range.start.getTime(),
            range.end.getTime(),
            compareRange?.start.getTime() ?? null,
            compareRange?.end.getTime() ?? null,
        ],
        () => SurveyAggregationService.getSummary({
            from: range.start,
            to: exclusiveEnd(range.end),
            compareFrom: compareRange?.start,
            compareTo: compareRange ? exclusiveEnd(compareRange.end) : undefined,
        }),
        {refetchOnWindowFocus: false, keepPreviousData: true}
    );

    const loading: InsightsLoading | undefined = query.isLoading
        ? 'skeleton'
        : query.isPreviousData
            ? 'refreshing'
            : undefined;

    return {summary: query.data, loading};
};
